// extracted by mini-css-extract-plugin
export default {"container":"ReturnPolicy_container__LLK5e","chatLink":"ReturnPolicy_chatLink__ijsbJ"};